import { initContract } from '@ts-rest/core'
import { GetProgramGenresRequestSchema, GetProgramGenresResponseSchema } from './schemas.ts'

const c = initContract()

export const programGenresContract = c.router(
  {
    list: c.query({
      method: 'GET',
      path: '/flight-deck/v1/program-genres',
      description: 'Get program genres for filtering',
      request: GetProgramGenresRequestSchema,
      responses: GetProgramGenresResponseSchema,
    }),
  },
  {
    strictStatusCodes: true,
    metadata: { tags: ['Flight Deck'] },
  },
)

export type ProgramGenresContract = typeof programGenresContract
